
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-virtual-mail-works",
      function () {
        return require("private-next-pages/how-virtual-mail-works.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-virtual-mail-works"])
      });
    }
  